import { render } from "./HeroiconsOutlineReceiptTax.vue?vue&type=template&id=f87c888a"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineReceiptTax.vue"]])

export default __exports__